<template>
     <div class="mainWrapper pb-0">
         <AppLoader v-if="loader" />
        <section class="blockElement space position-relative reatesPage" v-if="show && store.flavordata.flavorId">
            <div class="container">
              <h1 class="letter-space-0 medium mob-block f-28 darkblueColor mb-4">{{$t('TOSEU.eText17a')}}</h1>
                <vue-pdf-embed :source="`/assets/pdf/legal/Conflicts_Of_Interest_Policy_ZULUTRADE.pdf`" v-show="!store.flavordata?.isEu"  @loaded="Load" />
                <vue-pdf-embed :source="`/assets/pdf/legal/Conflicts_Of_Interest_Policy_ZULUTRADE.pdf`" v-show="store.flavordata?.isEu"  @loaded="Load" />
                </div>
        </section>
    </div>
</template>
<script>
import { myStore } from "@/store/pinia-store";
import VuePdfEmbed from 'vue-pdf-embed'
export default {
    setup() {
        const store = myStore();
        return { store };
    },
  data() {
    return {
        show : false,
        loader : false
    };
  },
  methods:{
    Load(e){
        if(e){
            this.loader = false
        }
    }
  },
  components : {
    VuePdfEmbed
  },
  mounted(){
    setTimeout(()=> {
        this.show = true
    },1000)
  },
  created(){
    this.loader = true
  }
};
</script>